import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/sign_bg.jpeg'
import _imports_1 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7bc764e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar flex-CN" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "login-img",
    src: _imports_1,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "欢迎使用安心付"),
    /*#__PURE__*/_createElementVNode("p", null, "签约H5应用程序")
  ])
], -1))
const _hoisted_3 = {
  class: "step-box flex-RN",
  "data-view": "no"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 0}),
        "data-view": "/UploadView"
      }, "选择任务", 2),
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 1}),
        "data-view": "/UploadView"
      }, "校验身份信息", 2),
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 2}),
        "data-view": "/BankView"
      }, "绑定账号", 2),
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 3}),
        "data-view": "/AgreeView"
      }, "合同签署", 2)
    ])
  ]))
}